import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Ekskul from "./Ekskul";

const ProfileSekolah = () => {
  const [schoolData, setSchoolData] = useState([]);
  const [dataKepsek, setDataKepsek] = useState([]);
  const [gambarList, setGambarList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    const fetchAll = async () => {
      try {
        const token = localStorage.getItem("token");

        const [schoolRes, kepsekRes, gambarRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_URL}api/datasekolah/all`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(
            `${process.env.REACT_APP_API_URL}api/auth/user-images-and-roles`
          ),
          axios.get(`${process.env.REACT_APP_API_URL}api/gambarsekolah`),
        ]);

        setSchoolData(schoolRes.data);
        setDataKepsek(
          kepsekRes.data.filter((user) => user.jabatan === "Kepala Sekolah")
        );
        setGambarList(gambarRes.data);
      } catch (err) {
        toast.error("Gagal memuat data profil sekolah");
        setError("Gagal memuat data");
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, []);

  if (loading)
    return (
      <div className="text-center py-20 text-gray-500">
        Memuat data sekolah...
      </div>
    );

  if (error)
    return <div className="text-center py-20 text-red-500">{error}</div>;

  return (
    <div className="bg-gradient-to-b from-blue-50 to-white dark:from-gray-900 dark:to-gray-800 min-h-screen">
      {/* ================= JUDUL ================= */}
      <div className="text-center py-16 px-4">
        <h1 className="text-3xl md:text-4xl font-extrabold text-blue-600 dark:text-yellow-400">
          Profil Sekolah
        </h1>
      </div>

      {/* ================= KEPALA SEKOLAH ================= */}
      <section className="max-w-7xl mx-auto px-4 py-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* Foto Kepsek */}
          <div className="flex justify-center">
            {dataKepsek.map((kepsek) => (
              <img
                key={kepsek._id}
                src={`${process.env.REACT_APP_API_URL}api/auth/users/image/${kepsek.image.filename}`}
                alt={kepsek.name}
                className="w-[260px] h-[360px] object-cover rounded-2xl shadow-xl"
              />
            ))}
          </div>

          {/* Sambutan */}
          <div>
            <h2 className="text-2xl md:text-3xl font-bold mb-4 text-gray-800 dark:text-white">
              Sambutan Kepala Sekolah
            </h2>

            {schoolData.map((school) =>
              school.salam_kepsek.map((item) => (
                <p
                  key={item._id}
                  className="text-gray-700 dark:text-gray-300 text-justify mb-4 leading-relaxed"
                >
                  {item.text}
                </p>
              ))
            )}

            {dataKepsek.map((kepsek) => (
              <div key={kepsek._id} className="mt-6">
                <p className="font-bold text-gray-800 dark:text-white">
                  {kepsek.name}
                </p>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Kepala Sekolah
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= SEJARAH ================= */}
      <section className="bg-blue-50 dark:bg-gray-900 py-16">
        <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* Gambar */}
          {gambarList.map((item) => (
            <img
              key={item._id}
              src={`${process.env.REACT_APP_API_URL}api/gambarsekolah/media/${item.gambar.filename}`}
              alt="Gambar Sekolah"
              className="rounded-2xl shadow-xl w-full h-72 object-cover"
            />
          ))}

          {/* Teks */}
          <div>
            <h2 className="text-2xl md:text-3xl font-bold mb-4 text-gray-800 dark:text-white">
              Sejarah Singkat
            </h2>
            {schoolData.map((school) =>
              school.sejarah_singkat.map((item) => (
                <p
                  key={item._id}
                  className="text-gray-700 dark:text-gray-300 text-justify leading-relaxed"
                >
                  {item.text}
                </p>
              ))
            )}
          </div>
        </div>
      </section>

      {/* ================= VISI MISI ================= */}
      <section className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {/* Visi */}
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6">
            <h3 className="text-xl font-bold mb-4 text-center text-blue-600">
              Visi Sekolah
            </h3>
            {schoolData.map((school) =>
              school.visi.map((item) => (
                <p
                  key={item._id}
                  className="italic text-center text-gray-700 dark:text-gray-300"
                >
                  “{item.isiVisi}”
                </p>
              ))
            )}
          </div>

          {/* Misi */}
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6">
            <h3 className="text-xl font-bold mb-4 text-center text-blue-600">
              Misi Sekolah
            </h3>
            <ul className="space-y-3">
              {schoolData.map((school) =>
                school.misi.map((item, index) => (
                  <li
                    key={item._id}
                    className="flex gap-2 text-gray-700 dark:text-gray-300"
                  >
                    <span className="font-bold">{index + 1}.</span>
                    <span>{item.isiMisi}</span>
                  </li>
                ))
              )}
            </ul>
          </div>
        </div>
      </section>

      {/* ================= EKSKUL ================= */}
      <Ekskul />

      {/* ================= DATA SEKOLAH ================= */}
      <section className="max-w-7xl mx-auto px-4 py-16">
        {schoolData.map((school) => (
          <div
            key={school._id}
            className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8"
          >
            <h2 className="text-2xl font-bold mb-6 text-blue-600">
              {school.namasekolah}
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700 dark:text-gray-300">
              <p>
                <b>NPSN:</b> {school.NPSN}
              </p>
              <p>
                <b>Akreditasi:</b> {school.Akreditasi}
              </p>
              <p>
                <b>Alamat:</b> {school.alamat}
              </p>
              <p>
                <b>Status:</b> {school.statusSekolah}
              </p>
              <p>
                <b>Kecamatan:</b> {school.Kec}, {school.kab}
              </p>
              <p>
                <b>Provinsi:</b> {school.prov}
              </p>
              <p>
                <b>Email:</b>{" "}
                <a
                  href={`mailto:${school.email}`}
                  className="text-blue-500 hover:underline"
                >
                  {school.email}
                </a>
              </p>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default ProfileSekolah;
